import React, { Component } from "react";
import styles from "./detailBloodStationInfo.module.scss";
import DetailBloodStation from "../../../entities/detail_blood_station";
import { get_city_label, getByPos, sendMetrics } from "../../../utils/misc";
import { Popup } from "semantic-ui-react";

export default class DetailBloodStationInfo extends Component<any, any> {
  props: {
    bloodStation: DetailBloodStation;
  };

  sendTo = (endLat, endLng) => {
    sendMetrics("go_to_ya_map");
    getByPos()
      .then((r) => {
        const { coords } = r;
        if (typeof window !== "undefined") {
          const sendTo = `https://yandex.ru/maps/?mode=routes&rtext=${coords.latitude}%2C${coords.longitude}~${endLat}%2C${endLng}&rtt=auto`;
          const win = window.open(sendTo, "_blank");
          if(win) win.focus();
        }
      })
      .catch(() => {
        if (typeof window !== "undefined") {
          const sendTo = `https://yandex.ru/maps/?mode=routes&rtext=~${endLat}%2C${endLng}&rtt=auto`;
          const win = window.open(sendTo, "_blank");
          if(win) win.focus();
        }
      });
  };

  render() {
    const { props, sendTo } = this;
    const { bloodStation } = props;
    const { address, title, city } = bloodStation;
    return (
      <>
        <div className={styles.DetailBloodStationInfo}>
          <div className={styles.DetailBloodStationInfo_Title}>
            <h1>{title}</h1>
          </div>
          <div className={styles.DetailBloodStationInfo_Body}>
            <div className={styles.DetailBloodStationInfo_Body_Image}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
                  stroke="#4E5355"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z"
                  stroke="#4E5355"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className={styles.DetailBloodStationInfo_Body_Left}>
              <span>
                {[get_city_label(city), address].filter(Boolean).join(", ")}
              </span>
              <Popup
                inverted
                basic
                closeOnDocumentClick
                hideOnScroll
                mouseEnterDelay={200}
                style={{ backgroundColor: "#333333" }}
                position={"top center"}
                trigger={
                  <p
                    onClick={() => {
                      sendTo(bloodStation.lat, bloodStation.lng);
                    }}
                  >
                    Проложить маршрут
                  </p>
                }
              >
                <span>
                  Опция может быть недоступна при выключеной геолокации
                </span>
              </Popup>
            </div>
          </div>
        </div>
      </>
    );
  }
}
